module.exports = __webpack_public_path__ + "img/book.cbf952e5.svg";